module.exports = __webpack_public_path__ + "static/media/010-dentist.7c196cbb.svg";